module.exports = __webpack_public_path__ + "img/default-course.fdac6434.png";